/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import { FormattedMessage } from 'js/lib/coursera.react-intl';

import { Typography2 } from '@coursera/cds-core';
import { StarRating } from '@coursera/coursera-ui';

import _t from 'i18n!nls/browse';

type Props = {
  averageFiveStarRating: number;
  ratingCount?: number;
  starSpacing?: number;
};

const styles = {
  ratings: css`
    margin: 14px 0;
  `,
  ratingsIcon: css`
    display: flex;
    margin-right: 12px;
    height: 18px;
    align-items: center;

    svg {
      height: 18px !important;
      width: 16px !important;
    }
  `,
  ratingsText: css`
    padding-right: 6px;
  `,
};

const Ratings = (props: Props) => {
  const { averageFiveStarRating, ratingCount, starSpacing = 5 } = props;
  const reviewsAriaLabel = ratingCount ? _t('#{ratingCount} reviews', { ratingCount }) : '';
  return (
    <div className="horizontal-box" css={styles.ratings}>
      <div css={styles.ratingsIcon}>
        <StarRating rating={averageFiveStarRating} starSpacing={starSpacing} />
      </div>
      <div className="screenreader-only">
        {_t('Rated #{averageFiveStarRating} out of five stars. #{reviewsAriaLabel}', {
          averageFiveStarRating,
          reviewsAriaLabel,
        })}
      </div>
      <Typography2 component="span" variant="subtitleMedium" css={styles.ratingsText} aria-hidden={true}>
        {averageFiveStarRating}
      </Typography2>
      {ratingCount ? (
        <Typography2 component="span" variant="bodySecondary" aria-hidden={true}>
          <FormattedMessage message="({count})" count={ratingCount.toLocaleString()} />
        </Typography2>
      ) : null}
    </div>
  );
};

export default Ratings;
